import { render, staticRenderFns } from "./NewMenuManagement.vue?vue&type=template&id=11fc75f7&"
import script from "./NewMenuManagement.vue?vue&type=script&lang=js&"
export * from "./NewMenuManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports